<template>
    <footer class="app-footer">
        <div class="footer-container">
            <div class="footer-section">
                <h3 class="footer-title">{{ $t('quick_links') }}</h3>
                <ul class="footer-links">
                    <li><router-link :to="{ name: 'home', params: { lang: $route.params.lang || 'nl' } }">{{ $t('home') }}</router-link></li>
                    <li><router-link :to="{ name: 'cars', params: { lang: $route.params.lang || 'nl' } }">{{ $t('all_vehicles') }}</router-link></li>
                    <li><router-link :to="{ name: 'about', params: { lang: $route.params.lang || 'nl' } }">{{ $t('about_us') }}</router-link></li>
                    <li><router-link :to="{ name: 'contact', params: { lang: $route.params.lang || 'nl' } }">{{ $t('contact.title') }}</router-link></li>
                    <li><router-link :to="{ name: 'sell_car', params: { lang: $route.params.lang || 'nl' } }">{{ $t('sell_car') }}</router-link></li>
                    <li><router-link :to="{ name: 'privacy_policy', params: { lang: $route.params.lang || 'nl' } }">{{ $t('privacy.title') }}</router-link></li>
                </ul>
            </div>
            
            <div class="footer-section">
                <h3 class="footer-title">{{ $t('contact_info') }}</h3>
                <ul class="contact-info">
                    <li>
                        <i class='bx bx-map'></i>
                        <a href="https://maps.app.goo.gl/KGVUKWtSKMagJufK8" target="_blank" rel="noopener">
                            Klein Holland 89, 1840 Londerzeel, Belgium
                        </a>
                    </li>
                    <li>
                        <i class='bx bx-phone'></i>
                        <a href="tel:+3252482885">+32 52 48 28 85</a>
                    </li>
                    <li>
                        <i class='bx bx-envelope'></i>
                        <a href="mailto:info@bassmotors.be">info@bassmotors.be</a>
                    </li>
                </ul>
            </div>
            
            <div class="footer-section">
                <h3 class="footer-title">{{ $t('opening_hours') }}</h3>
                <ul class="opening-hours">
                    <li>{{ $t('monday_friday') }}</li>
                    <li>{{ $t('saturday') }}</li>
                    <li>{{ $t('sunday') }}</li>
                    <li>{{ $t('by_appointment_only') }}</li>
                </ul>
            </div>
            
            <div class="footer-section">
                <h3 class="footer-title">{{ $t('follow_us') }}</h3>
                <div class="social-media">
                    <a href="#" class="social-icon"><i class='bx bxl-facebook'></i></a>
                    <a href="#" class="social-icon"><i class='bx bxl-twitter'></i></a>
                    <a href="#" class="social-icon"><i class='bx bxl-instagram'></i></a>
                    <a href="#" class="social-icon"><i class='bx bxl-youtube'></i></a>
                </div>
            </div>
        </div>
        
        <!-- <div class="footer-bottom">
            <p>{{ $t('copyright', { year: currentYear }) }}</p>
            <p><router-link :to="{ name: 'privacy_policy', params: { lang: $route.params.lang || 'nl' } }">{{ $t('privacy.title') }}</router-link></p>
        </div> -->
        <div class="footer-bottom" style="text-align: center;">
  <p style="margin: 0;">
    {{ $t('copyright', { year: currentYear }) }}
    •
    <router-link
      :to="{ name: 'privacy_policy', params: { lang: $route.params.lang || 'nl' } }"
      style="color: inherit; text-decoration: none; margin-left: 0.25rem;"
    >
      {{ $t('privacy.title') }}
    </router-link>
  </p>
</div>
    </footer>
</template>

<script setup>
import { ref } from 'vue'

const currentYear = ref(new Date().getFullYear())
</script>

<style scoped>
.app-footer {
    background-color: #222;
    color: #fff;
    padding: 40px 0 0;
    margin-top: auto;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 30px;
}

.footer-section {
    margin-bottom: 30px;
}

.footer-title {
    color: #45ABFF;
    font-size: 1.2rem;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;
}

.footer-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background-color: #45ABFF;
}

.footer-links li,
.contact-info li,
.opening-hours li {
    margin-bottom: 10px;
}

.footer-links a,
.contact-info li,
.opening-hours li {
    color: #bbb;
    transition: color 0.3s;
    text-decoration: none;
}

.footer-links a:hover {
    color: #45ABFF;
}

.contact-info a {
    color: inherit;
    text-decoration: none;
}


.contact-info i,
.opening-hours i {
    margin-right: 8px;
    color: #45ABFF;
}

.social-media {
    display: flex;
    gap: 15px;
}

.social-icon {
    color: #fff;
    font-size: 1.5rem;
    transition: color 0.3s;
}

.social-icon:hover {
    color: #45ABFF;
}

.footer-bottom {
    background-color: #111;
    padding: 15px 0;
    text-align: center;
    margin-top: 30px;
}

.footer-bottom p {
    margin: 0;
    color: #999;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .footer-container {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 480px) {
    .footer-container {
        grid-template-columns: 1fr;
    }
}
</style>
